import SwipeableDrawerWithBackNavigation from './swipeableDrawer'

export default SwipeableDrawerWithBackNavigation
